import { ILiteTradeAssets } from "../../../types/liteTradeReducer.t";
import { useSelector } from "react-redux";
import { getAppFeatures } from "../../../../../app/appSelectors";
import { useMemo } from "react";
import _ from "lodash";
import { FEATURES } from "../../../../../app/appConstants";
import Asset from "../../../../Asset/Asset";

function useFilteredAssets(assets: ILiteTradeAssets, searchValue: string) {
    const features = useSelector(getAppFeatures);

    return useMemo(() => {
        const regexpSearchValue = new RegExp(_.escapeRegExp(searchValue), 'i');
        return _.chain(assets)
            .filter(asset => !features[FEATURES.DEMO_MODE] || !!asset.asset_class)
            .filter(asset => asset.active)
            .filter(asset => regexpSearchValue.test(asset.symbol) || regexpSearchValue.test(asset.info?.description))
            .map(asset => {
                const assetInstance = new Asset(asset);
                return ({
                    ...asset,
                    assetInstance,
                    lowerDescription: _.toLower(asset.info?.description),
                    inactive: !assetInstance.isTradingNow(),
                });
            })
            .sortBy(['inactive', 'lowerDescription'])
            .value()
    }, [assets, features, searchValue])
}

export default useFilteredAssets;